export type ConversationAuthorization =
  | { agentId: string }
  | { getSignedUrl: () => Promise<string> };

/** Authenticated conversations never fall back to the public-agent connection. */
export const getConversationAuthorization = async (
  authorization: ConversationAuthorization,
) => {
  if ('getSignedUrl' in authorization) {
    const signedUrl = await authorization.getSignedUrl();
    if (!signedUrl) throw new Error('Interview authorization is unavailable.');
    return { signedUrl };
  }
  return { agentId: authorization.agentId };
};

/** SDK connection errors can contain a signed URL; keep that capability out of analytics. */
export const safeConversationError = (
  error: unknown,
  authenticated: boolean,
) =>
  authenticated
    ? new Error('The authorized voice conversation could not connect.')
    : error instanceof Error
      ? error
      : new Error(String(error));
